import React, { useEffect, useContext } from "react";
import { ContextGetData } from "../../services/getData";
import { ContextoListaApartamentos } from "./contextoImoveis";
import { Spinner } from "../StyledComponent";
import LogoDirecional from "../../assets/novosicones/SeletorImoveis/Direcional_RGB.png";
import LogoRivaPequeno from "../../assets/novosicones/SeletorImoveis/RivaX_PNG_colorida.png";
import { ReactComponent as PlaceIcon } from "../../assets/novosicones/SeletorImoveis/placeIcon.svg";
import { ReactComponent as ArrowUpDown } from "../../assets/unfold_more_black_24dp.svg";
import Fade from "@material-ui/core/Fade";
import "./styles.scss";

const ApartamentList = () => {
  let home = false;
  var url = window.location.href.toString();
  if (url.includes("interna")) home = true;

  if (!home) return null;

  const { imoveis } = useContext(ContextGetData);
  const {
    setImovelAtual,
    imovelAtual,
    tema,
    setImovelFunction,
    imovelSelecionado,
    setImovelSelecionado,
    selected,
    setSelected,
    meusImoveis,
    selectApartament,
    loadingApartamentList,
  } = useContext(ContextoListaApartamentos);

  useEffect(() => {
    let selecionado = document.getElementsByClassName(
      "itemApartamentList--selecionado"
    );
    if (selecionado[0] != undefined)
      selecionado[0].style.color = tema.primaryColor;
  }, [tema]);

  useEffect(() => {
    if (!imovelSelecionado) {
      setSelected(false);
      if (!selected) {
        if (imoveis.length) {
          setImovelFunction(imoveis[0]);
        }
      }
    }
  }, [imoveis]);

  const showApartamentList = () => {
    document
      .getElementById("aPlist")
      .classList.toggle("seletorImovel__apartamentList__list--showList");
  };

  window.onclick = function (event) {
    if (
      !event.target.matches(".seletorImovel__apartamentList") &&
      !event.target.matches(".seletorImovel__apartamentList__list") &&
      !event.target.matches(".seletorImovel__apartamentList__selected") &&
      !event.target.matches(".emNegrito") &&
      !event.target.matches("#bntShowApartamentList") &&
      !event.target.matches(".arrowsSeletor")
    ) {
      let lista = document.getElementById("aPlist");
      if (lista != null)
        lista.classList.remove("seletorImovel__apartamentList__list--showList");
    }
  };

  if (!home) return null;

  if (!meusImoveis.length) return <Spinner />;

  if (loadingApartamentList && home) return <Spinner />;

  if (!imovelAtual.tipo) return <Spinner />;

  return (
    <div
      className="seletorImovel centralized-space-between"
      style={!home ? { display: "none" } : { display: "flex" }}
    >
      <div className="seletorImovel__logoPequeno">
        {imovelAtual.tipo === "DIRECIONAL ENGENHARIA S.A." && (
          <Fade in={true}>
            <>
              <img
                src={LogoDirecional}
                className="seletorImovel__logoPequeno__single"
              />
            </>
          </Fade>
        )}
        {imovelAtual.tipo === "RIVA INCORPORADORA S.A" && (
          <Fade in={true}>
            <img
              src={LogoRivaPequeno}
              className="seletorImovel__logoPequeno__single"
            />
          </Fade>
        )}
      </div>
      <div
        className="seletorImovel__apartamentList centralized"
        id="bntShowApartamentList"
        onClick={() => {
          meusImoveis.length > 1 && showApartamentList();
        }}
      >
        <span className="seletorImovel__apartamentList__placeIcon">
          <PlaceIcon />
        </span>

        <div className="seletorImovel__apartamentList__selected centralized">
          <span className="emNegrito">{imovelSelecionado}</span>

          {meusImoveis.length > 0 ? (
            <Fade in>
              <div
                className="seletorImovel__apartamentList__list centralized"
                id="aPlist"
              >
                <ul>
                  {meusImoveis.map((imovel, index) => (
                    <li
                      style={{ zIndex: "99" }}
                      className="itemApartamentList centralized-space-between"
                      id={imovel.id}
                      key={index}
                      onClick={() => {
                        setImovelAtual(imovel);
                        setImovelSelecionado(imovel.nome);
                        setSelected(true);
                        selectApartament(imovel.nome);
                        sessionStorage.setItem(
                          "imovelAtual",
                          JSON.stringify(imovel)
                        );
                      }}
                    >
                      {imovel.tipo == "DIRECIONAL ENGENHARIA S.A." && (
                        <img
                          style={{ width: "10%" }}
                          src={LogoDirecional}
                          alt=""
                        />
                      )}
                      {imovel.tipo == "RIVA INCORPORADORA S.A" && (
                        <img
                          style={{ width: "10%" }}
                          src={LogoRivaPequeno}
                          alt=""
                        />
                      )}
                      {imovelSelecionado == imovel.nome && (
                        <span style={{ color: tema.primaryColor }}>
                          {imovel.nome}
                        </span>
                      )}
                      {imovelSelecionado != imovel.nome && (
                        <span>{imovel.nome}</span>
                      )}
                    </li>
                  ))}
                </ul>
                <ArrowUpDown
                  className="seletorImovel__apartamentList__list__arrowUpDown"
                  style={{ fill: "#848484" }}
                />
              </div>
            </Fade>
          ) : (
            <div className="seletorImovel__apartamentList__list" id="aPlist">
              <p>Imóveis indisponíveis</p>
            </div>
          )}
          {/* caso o usuário possua somente 1 imóvel o botão de alterar imóvel é escondido */}
          {meusImoveis.length > 1 && (
            <ArrowUpDown
              onClick={() => {
                showApartamentList();
              }}
              className="arrowSelector"
              style={{ fill: "#848484" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ApartamentList;
